import { make, type preset } from './OverlayTriggerView.gen'

type OverlayTriggerViewProps = React.ComponentProps<typeof make>

const OverlayTriggerView =
  make as React.FunctionComponent<OverlayTriggerViewProps>

export {
  OverlayTriggerView,
  type OverlayTriggerViewProps,
  type preset as Preset,
}
